import "./index.css"
import { useState } from "react";
import Button from "../button";
import { RegenerateYourPost } from "../../functions/regenIdea";


function RegenModule({close,id,display}) {

  const completeRegeneration = async(id) => {
    console.log("Complete regeneration of " + id);
    await RegenerateYourPost(id,document.getElementById("regen-feedback").value);
  }

    return <div id="regen-module-holder" style={{display:display}}>
        <div id="regen-module">
        <div className="idea-schedule-header">
          <h2 className="idea-schedule-month">Regenerate your post</h2>
          <img className="idea-schedule-icon close" onClick={close} src="./images/close.png"></img>

        </div>
        <textarea id="regen-feedback" className="small-text" placeholder="What do you want to change about the post?"></textarea>
        <div>
        <Button text="Regenerate" addedFunction={completeRegeneration} params={id}></Button>
        </div>
        </div>
    </div>
  }

export default RegenModule;